<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">耗材领用审批</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="[1]" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="耗材名称">
          <el-input v-model="formInline.product_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus2" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期">
          <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
            clearable start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="product_name" label="耗材名称" min-width="150">
        </custom-table-column>
        <custom-table-column fixed prop="product_number" label="耗材编号" min-width="150">
        </custom-table-column>
        <custom-table-column prop="status" label="状态" width="80" label-class-name="reviewStatus2"
          :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="apply_quantity" label="领用数量" width="80">
        </custom-table-column>
        <custom-table-column prop="syyt" label="使用用途" width="80">
        </custom-table-column>
        <custom-table-column prop="syzs" label="使用周数" width="80">
        </custom-table-column>
        <custom-table-column prop="lyr" label="领用人" width="80">
        </custom-table-column>
        <custom-table-column prop="bj" label="班级" width="120">
        </custom-table-column>
        <custom-table-column prop="kcmc" label="课程" width="140">
        </custom-table-column>
        <custom-table-column prop="rs" label="人数" width="80">
        </custom-table-column>
        <custom-table-column prop="apply_reason" label="申请理由" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <!-- <custom-table-column prop="apply_structure_2" label="专业" width="180">
        </custom-table-column> -->
        <custom-table-column prop="approver_name" label="审批人" width="100px">
        </custom-table-column>
        <custom-table-column prop="approve_remark" label="说明原因" width="160px">
        </custom-table-column>
        <custom-table-column prop="record_number" label="出库单号" width="140">
        </custom-table-column>
        <custom-table-column prop="approve_date" label="审批时间" width="160px">
        </custom-table-column>
        <custom-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.status == 'apply'" @click="handleOper(scope.row.id, 'pass')" type="text"
              size="small">审批</el-button> -->
            <el-button v-if="scope.row.status == 1" @click="handleOper(scope.row, 2)" type="text"
              size="small">通过</el-button>
            <el-button v-if="scope.row.status == 1" @click="handleOper(scope.row, 3)" type="text"
              size="small">否决</el-button>
            <el-button v-if="scope.row.status == 2&& !scope.row.record_number" @click="handleApplyBack(scope.row.id)" type="text"
              size="small">打回</el-button>
            <el-button v-if="scope.row.status == 2&& !scope.row.record_number" @click="handleEditChild(scope.row)" type="text"
              size="small">出库登记</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="500px">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="说明原因" prop="approve_remark" :rules="isRefuse">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.approve_remark"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <ConsumableBorrowChlid ref="digChild" :digVisible='visibleChildDialog'  @closeDig="closeDig">
    </ConsumableBorrowChlid>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinValidate } from '@/assets/js/mixin/validate';
import ConsumableBorrowChlid from './component/consumableBorrowChlid.vue';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan, mixinFormatter, mixinValidate],
  data() {
    return {
      formInline: {
        product_name: '',
        structure_1: '',
        status: '',
        start_date: '',
        end_date: '',
        date: '',
      },
      visibleChildDialog: false,
      levell: [1, 2],
      centerDialogVisible: false,
      detailDialogVisible: false,
      rowObj: {},
      chemicals: [],
      curChems: [],
      rules: {
      },
      rulesRoot: {
        approve_remark: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      ruleForm: {
        id: '',
        status: '',
        approve_remark: '',
      },
    };
  },
  components: {
    ConsumableBorrowChlid
  },
  computed: {
    isRefuse() {
      return this.ruleForm.status == 3 ? [{ required: true, message: '请输入', trigger: 'blur' }] : [];
    },
  },
  created() { },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
  },
  methods: {
    closeDig(flag = false) {
      this.visibleChildDialog = false
      if(flag){
        this.getList()
      }
    },
    handleEditChild(row) {
      this.visibleChildDialog = true
      this.$refs.digChild.handleEditInit(row)
    },
    handleOper(row, status) {
      this.title = status == 3 ? '否决' : '通过';
      this.centerDialogVisible = true;
      this.ruleForm.status = status;
      this.ruleForm.id = row.id;
    },
    async setStatus() {
      let res = await this.$api.instance.interfaceServer(`api/consume/apply/approve`, 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.centerDialogVisible = false
        this.getList();
      }
    },
    handleApplyBack(id) {
      this.confirmBox('warning', `此操作将打回该领用申请，是否继续`, { id }, this.backMethod);
    },
    async backMethod(params) {
      let res = await this.$api.instance.interfaceServer('api/consume/apply/rollback', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '打回成功！',
        });
        this.handleQuery();
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceScrap(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.items = params.items.map((item) => {
        return {
          type: item.type,
          name: item.name,
          num: item.num,
          id: item.id,
        };
      });
      params.items = JSON.stringify(params.items);
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      if (params.date && params.date.length > 0) {
        params.start_date = params.date[0];
        params.end_date = params.date[1];
        delete params.date;
      }
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/consume/apply/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.el-select-dropdown__item {
  height: auto !important;
  line-height: 20px;
  padding: 4px 30px;
}
</style>
